<script setup lang="ts">
import ReserveError from '@components/util/ReserveError.vue';
import CountDownTimer from '@components/util/CountDownTimer.vue';

const itineraryStore = useItineraryStore();
const { listErrorReason } = storeToRefs(itineraryStore);
const router = useRouter();
const onTimeout = () => itineraryStore.loadAvailable();
</script>

<template>
    <ReserveError
        v-if="listErrorReason.type === 'Network'"
        wrapper-id="connection-lost-offline"
        error="خطایی در ارتباط رخ داد. لطفاً از اتصال خود به اینترنت مطمئن شوید و یا در صورت استفاده از فیلترشکن آن را خاموش و مجدداً تلاش کنید."
        @research="router.replace('/')"
    />
    <div v-else>
        <div :id="listErrorReason.id" class="list-loading-error" dir="rtl">
            <br />
            <div
                v-if="
                    listErrorReason.type === 'Timeout' &&
                    listErrorReason.timeout
                "
                class="error-timeout"
            >
                <CountDownTimer
                    :deadline="listErrorReason.timeout"
                    @timeout="onTimeout"
                />
            </div>
            <img
                v-else
                class="error-image"
                :src="listErrorReason.image"
                alt="error"
            />
            <h3>
                {{ listErrorReason.message }}
                <br />{{ listErrorReason.description }}
            </h3>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.list-loading-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h3 {
        text-align: center;
        @include font-weight();
    }
}

.error-image {
    width: 50%;
    @include mobile-only() {
        width: 192px;
        height: 162px;
    }
}

.error-timeout {
    padding: 30px;
}
</style>
